



export enum ParticipantLevel {
    To = 'to',
    CC = 'cc',
    BCC = 'bcc'
}
